import { FC } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { PaginatorWithResult } from 'jbc-front/components/SearchForm';
import { LoadingPage } from '@/components/LoadingPage';
import { Content } from '@/components/layout/Content';
import { useDisplayEmployeeLimit } from '@/components/utils/display_employee_limit';
import { useQuery } from '@/hooks/graphql/useQuery';
import { USERS, Users as UsersQueryResult, UsersQueryVariables } from './query';
import {
  convertSearchParamsToGraphQL,
  getSearchParamsFromLocation,
  convertSearchParamsToQueryString,
  convertSearchParamsToForm,
  convertFormToSearchParams
} from './search';
import { SearchForm } from './parts/SearchForm';
import { UsersTable } from './parts/UsersTable';

export const Users: FC = () => {
  const location = useLocation();
  const history = useHistory();
  const [limit] = useDisplayEmployeeLimit();
  const searchParams = { ...getSearchParamsFromLocation(location), limit };

  const { data, loading, refetch } = useQuery<UsersQueryResult, UsersQueryVariables>(USERS, {
    variables: convertSearchParamsToGraphQL(searchParams),
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true
  });
  const users = data?.client?.users?.list || [];

  return (
    <div>
      <div className="l-main-title-wrap">
        <h1 className="m-title-main">権限管理</h1>
      </div>
      <Content size="xl-3">
        <div className="l-breadcrumb u-mb40">
          <Link to="/settings" className="l-breadcrumb-link">
            設定
          </Link>
          <span className="l-breadcrumb-here">権限管理</span>
        </div>
        <SearchForm
          values={convertSearchParamsToForm(searchParams)}
          totalCount={data?.client?.users?.totalCount}
          isLoading={loading}
          onSubmit={values => {
            const { _page, ...newSearchParams } = convertFormToSearchParams(values); // reset page
            history.push({ search: convertSearchParamsToQueryString(newSearchParams) });
          }}
        />
        {loading ? (
          <LoadingPage />
        ) : !data?.client ? (
          <div className="l-wrap-xs u-pt100">
            <div className="l-box-message">
              <p className="m-title-sub u-pt0 u-ta-c">管理者を取得できませんでした。</p>
            </div>
          </div>
        ) : (
          <UsersTable users={users} refetch={refetch} />
        )}
        <PaginatorWithResult
          onClick={(page: number) =>
            history.push({ search: convertSearchParamsToQueryString({ ...searchParams, _page: String(page) }) })
          }
          limit={limit}
          count={data?.client?.users?.totalCount}
          page={searchParams._page}
          isLoading={loading}
          failureMessage="管理者が見つかりませんでした"
        />
      </Content>
    </div>
  );
};
